/* eslint-disable no-invalid-this */

function or(...args) {
  return Boolean(args.find(arg => arg.toString() === "true"));
}

export default or;
